import React, { useState } from "react";
import { Button } from "rsuite";
import { toast } from "react-toastify";

import { getCadastroExcel } from "../../../../../Services/programation.service";

// Exporta TODO o cadastro (produtores, fazendas e talhões) em Excel.
// Não depende de safra: é uma foto do que está registrado hoje.
export const CadastroExcel = () => {
  const [gerando, setGerando] = useState(false);

  const handleDownload = async () => {
    setGerando(true);
    const { res } = await getCadastroExcel();
    setGerando(false);

    if (!res?.data || res.status === 404) {
      toast.warning("Nenhum talhão cadastrado para exportar.");
      return;
    }

    const hoje = new Date().toISOString().slice(0, 10);
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `Cadastro_Produtores_Fazendas_Talhoes_${hoje}.xlsx`);
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="generating-container-reports">
      <div style={{ margin: "15px", color: "#3A3F3A" }}>
        Gera uma planilha com todos os produtores, fazendas e talhões cadastrados,
        com a área de cada um. Traz também um resumo por produtor.
      </div>
      <Button
        className="button-generate-reports"
        variant="danger"
        size="lg"
        loading={gerando}
        onClick={handleDownload}
        style={{ marginLeft: "20px" }}
      >
        Gerar Planilha
      </Button>
    </div>
  );
};
